export default __webpack_public_path__ + "static/media/pear-reversed.0638678c.svg";